module.exports = __webpack_public_path__ + "7d9a38ad3b4eefa1af383a241d89e07f.pdf";